import type { FaireProductEntity } from "../../entity_types/product";

export const p_69rft48z97: FaireProductEntity = {
  token: "p_69rft48z97",
  type: "product",
  name: "Croissant Sticky Notes",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/accc1d2fae837b285072938bd423e6370148e9764fa65ca935e127daac5cacb6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/195c17db79c7974e5193681b25c993fa38f8ec9a45dde14e8d725dbfe10c43dc.jpeg",
    "https://cdn.faire.com/fastly/c9420677c03536aa491bfe90ee37676eb689ea090c1aa697dfb6ea1bba9281f9.jpeg",
    "https://cdn.faire.com/fastly/1ed5afa26b02747d5daca5b7650030b5bfcc118104d957d9bf8fc0e5cdbcd9d9.jpeg",
    "https://cdn.faire.com/fastly/27f7584ee53390692087998279b274f541fdbaeed0149e6602174814937cda74.jpeg"
  ],
  priceDollars: 4,
  description: "Croissant Notes are inspired by slow mornings, corner cafés, and lists made over coffee. This food-illustrated sticky note brings the warm and flakey bakery vibes to your desk, planner, or notebook—perfect for reminders, to-dos, and love notes slipped onto loose papers.\n\nA must-have for stationery lovers, foodies, and design-forward desks, Croissant Notes make everyday organization feel a little more indulgent.\n\n𝐆𝐨𝐨𝐝 𝐭𝐨 𝐤𝐧𝐨𝐰:\n\n• 50 adhestive sheets\n• Stick & restick anywhere.\n• Measures 3in x 3in\n• 100% Recyclable",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:33:07.990Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
